import { Control, Controller, FieldErrors, UseFormRegister } from 'react-hook-form'
import { FC } from 'react'
import { MenuItem, TextField } from '@mui/material'
import { formPropsDrawerCrud } from '../../constants/formPropsDrawerCrud'
import { TRpStandFormData } from './schema'

type Option = {
  value: string
  label: string
}

type TRpStandFormBaseProps = {
  register: UseFormRegister<TRpStandFormData>
  errors: FieldErrors<TRpStandFormData>
  control: Control<TRpStandFormData>
  streamOptions: Option[]
}

const RpStandFormBase: FC<TRpStandFormBaseProps> = ({ register, errors, control, streamOptions }) => {
  const fieldProps = { ...formPropsDrawerCrud }

  return (
    <>
      <TextField
        {...fieldProps}
        {...register('name')}
        label="Имя"
        error={!!errors.name}
        helperText={errors.name?.message}
        InputLabelProps={{ shrink: true }}
      />
      <Controller
        name="stream"
        control={control}
        render={({ field: { value, onChange } }) => (
          <TextField
            {...fieldProps}
            select
            label="Видеопоток"
            error={!!errors.stream}
            helperText={errors.stream?.message}
            InputLabelProps={{ shrink: true }}
            value={value}
            onChange={onChange}>
            <MenuItem value="">
              <em>Не выбрано</em>
            </MenuItem>
            {streamOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </>
  )
}

export default RpStandFormBase
